@charset "UTF-8";

/* src/app/forms/simple-datatree/simple-datatree.component.scss */
.simpletable {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  height: 100%;
  display: flex;
  padding: 10px;
  flex-direction: column;
  overflow: hidden;
}
mwlResizable {
  box-sizing: border-box;
}
.resize-handle-right {
  position: relative;
  height: 100%;
  cursor: col-resize;
  width: 5px;
  border-style: solid;
}
.resize-handle-right {
  right: 0;
}
.datagrid-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  padding: var(--tem-space-2) var(--tem-space-3);
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
  font-family: var(--tem-font-family);
}
.filter-select {
  width: 100%;
  min-width: 180px;
}
.menu-label {
  margin-left: var(--tem-space-2);
}
.tree-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .tree-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.tree-tools {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
  padding-bottom: var(--tem-space-2);
}
.tree-search {
  flex: 1;
}
:host ::ng-deep nz-tree {
  flex: 1;
  overflow: auto;
}
.mouseOut {
  display: none;
  opacity: 0;
  transition: opacity 1s ease-out;
  -webkit-animation: fade-out 1s;
  animation: fade-out 1s;
}
.mouseOver {
  visibility: visible;
  opacity: 1;
  -webkit-animation: fade-in 1s;
  animation: fade-in 1s;
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
#editar.mouseOver:hover {
  color: var(--tem-deep);
}
#excluir.mouseOver:hover {
  color: var(--tem-danger);
}
.mainclass {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.item-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item-filter .name {
  font-size: larger;
}
.item-filter .space {
  flex-grow: 1;
}
.item-filter .editicons {
  font-size: larger;
}
.atualizar {
  font-size: 14px;
  margin-right: 15px;
  margin-top: 15px;
}
.main-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  padding-top: 4px;
}
.main-content-edit {
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 4px;
  position: relative;
}
editform {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 4px;
}
.span1 {
  margin-left: 10px;
}
.div2 {
  width: 100%;
}
.span2 {
  margin-left: 25%;
}
.spacer {
  flex-grow: 1;
}
.column-template {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
.texto {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  width: 100%;
}
.fakeicon {
  width: 24px;
  height: 24px;
  display: inline-flex;
}
.data-col {
  display: flex;
  align-items: center;
}
::ng-deep .ngx-datatable .datatable-icon-skip:before {
  content: "q";
}
::ng-deep .ngx-datatable .sortable .sort-btn:before {
  font-family: data-table;
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-down:before {
  content: "f";
}
::ng-deep .ngx-datatable .sortable .sort-btn.datatable-icon-up:before {
  content: "e";
}
::ng-deep .datatable-body-row.active .datatable-row-group {
  background-color: #56f6d8 !important;
}
.server-scrolling {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.icon-filter {
  cursor: pointer;
}
.summary {
  width: 100%;
  display: flex;
  padding: 4px;
  border: solid 1px;
  border-color: #bdc3c7;
  border-color: var(--ag-border-color, #bdc3c7);
}
.totalLines {
  padding-left: 12px;
}
.alert-message {
  border-radius: 16px;
  background-color: red;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 400;
  display: flex;
  align-items: end;
}
.blinker {
  animation: blinker 3s step-start infinite;
  color: yellow;
  margin-right: 10px;
  margin-left: 10px;
}
.alert-message .message {
  font-size: 12px;
  margin-right: 10px;
  color: white;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.lines {
  padding-right: 12px;
}
/*# sourceMappingURL=simple-datatree.component.css.map */
